import { OPERATION_IDS, ROUTE_IDS } from '../routes/ids.js';
import { PLATFORM_MODULES_TABLE as DECLARED_PLATFORM_MODULES_TABLE } from './platform-admin-live-descriptors.js';
const configureAction = {
    id: 'action.platformModule.configure',
    schemaVersion: DECLARED_PLATFORM_MODULES_TABLE.schemaVersion,
    module: DECLARED_PLATFORM_MODULES_TABLE.module,
    feature: DECLARED_PLATFORM_MODULES_TABLE.feature,
    privacyClassification: DECLARED_PLATFORM_MODULES_TABLE.privacyClassification,
    telemetryId: 'experience.platform-admin.action.platformModule.configure',
    accessibilityLabelKey: 'action.edit',
    availability: 'AVAILABLE',
    owner: 'experience-registry',
    operationId: OPERATION_IDS.PLATFORM_MODULES_ASSIGN,
    labelKey: 'action.edit',
    iconKey: 'edit',
    kind: 'navigate',
    intent: 'primary',
    idempotencyRequired: false,
    successBehavior: 'NAVIGATE_TO',
    targetRouteId: ROUTE_IDS.PLATFORM_MODULES_DETAIL,
    successNavigateTo: '/platform/modules/:id',
    errorBehavior: 'SHOW_INLINE_ERROR',
    order: 5,
    group: 'navigation',
};
/**
 * Runtime-effective platform module table. The historical declaration used the
 * organization-admin module query name; the live platform surface owns a
 * dedicated cross-organization query and must advertise the same binding id as
 * the resource adapter.
 */
export const PLATFORM_MODULES_TABLE = Object.freeze({
    ...DECLARED_PLATFORM_MODULES_TABLE,
    dataSourceId: 'query.platform-admin.modules.list',
    rowActions: [configureAction, ...(DECLARED_PLATFORM_MODULES_TABLE.rowActions ?? [])],
});
